// extracted by mini-css-extract-plugin
export default {"bookmarkButton":"BookmarkButton_bookmarkButton__0vIwX","bookmarked":"BookmarkButton_bookmarked__y2Eu5"};